import { createStore, applyMiddleware, compose } from 'redux';
import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';
import logger from 'redux-logger';

import { reducers } from './reducers/index';

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'json',
});

const middlewareConfig = {
  onError: ({ action, dispatch, error: { message } }) => {
    dispatch({ type: action.type + '_FAIL', payload: { error: message } });
  },
};

// add the middlewares
let middlewares;
if (process.env.NODE_ENV !== 'production') {
  middlewares = [axiosMiddleware(client, middlewareConfig), logger];
} else {
  middlewares = [axiosMiddleware(client, middlewareConfig)];
}

// apply the middleware
let middleware = applyMiddleware(...middlewares);

// add the redux dev tools
if (process.env.NODE_ENV !== 'production' && window.devToolsExtension) {
  middleware = compose(middleware, window.devToolsExtension());
}

// create the store
const store = createStore(reducers, middleware);

// export
export { store };
